module.exports = __webpack_public_path__ + "assets/8c70e4afd3bf8a2ab375837e434163d6.png";